import { PlatformCatalogAccessMatchingRuleCriteria } from "@bvhi/backend-api/apis";
import { FormSelect, SelectChangeEvent } from "@bvhi/ui-base";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useMatchingRules } from "../../../../../../hooks/useMatchingRules";

interface Props {
  name: string;
  changeCallback?: (e: SelectChangeEvent<unknown>) => void;
}

export const PlatformCatalogAccessMatchingRuleCriteriaSelectField = ({ name, changeCallback }: Props) => {
  const { control } = useFormContext();
  const { t } = useTranslation(["catalogs", "enums"]);
  const { getMatchingCriteriaStringRepresentation } = useMatchingRules();

  return (
    <FormSelect
      changeCallback={changeCallback}
      control={control}
      fullWidth
      name={name}
      placeholder={t("catalogs:catalogs.form.fields.criteria.placeholder")}
      selectLabel={t("catalogs:catalogs.form.fields.criteria.label")}
      items={[
        {
          value: PlatformCatalogAccessMatchingRuleCriteria.EQUALS,
          label: getMatchingCriteriaStringRepresentation(PlatformCatalogAccessMatchingRuleCriteria.EQUALS),
        },
        {
          value: PlatformCatalogAccessMatchingRuleCriteria.NOT_EQUALS,
          label: getMatchingCriteriaStringRepresentation(PlatformCatalogAccessMatchingRuleCriteria.NOT_EQUALS),
        },
        {
          value: PlatformCatalogAccessMatchingRuleCriteria.HIGHER,
          label: getMatchingCriteriaStringRepresentation(PlatformCatalogAccessMatchingRuleCriteria.HIGHER),
        },
        {
          value: PlatformCatalogAccessMatchingRuleCriteria.HIGHER_OR_EQUALS,
          label: getMatchingCriteriaStringRepresentation(PlatformCatalogAccessMatchingRuleCriteria.HIGHER_OR_EQUALS),
        },
        {
          value: PlatformCatalogAccessMatchingRuleCriteria.LOWER,
          label: getMatchingCriteriaStringRepresentation(PlatformCatalogAccessMatchingRuleCriteria.LOWER),
        },
        {
          value: PlatformCatalogAccessMatchingRuleCriteria.LOWER_OR_EQUALS,
          label: getMatchingCriteriaStringRepresentation(PlatformCatalogAccessMatchingRuleCriteria.LOWER_OR_EQUALS),
        },
      ]}
    />
  );
};
